import { render, staticRenderFns } from "./metasCantidad.vue?vue&type=template&id=93f50ef4&scoped=true&"
import script from "./metasCantidad.vue?vue&type=script&lang=js&"
export * from "./metasCantidad.vue?vue&type=script&lang=js&"
import style0 from "./metasCantidad.vue?vue&type=style&index=0&id=93f50ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f50ef4",
  null
  
)

export default component.exports